import groq from 'groq'

export const vimeoObject = groq`
vimeoObject {...,}`
